<template>
	<div :class="classNames">
		<div :class="classNames+ '_title'">
			抖音群聊
			<!-- <a :class="classNames+ '_alink'" style="margin-left: 12px;">如何创建抖音群聊？</a> -->
		</div>
		<div :class="classNames+ '_tips'">
			<p class="tips_item">1、授权前，请先确认该授权抖音账号已实名认证且有开播记录，或者粉丝数为万粉，否则授权后不可创建群聊;</p>
			<p class="tips_item">2、一个账号可以授权多个抖音号，一个课程可关联多个群聊，一个群聊可以被多个课程关联;</p>
			<p class="tips_item">3、课程关联群聊之后，将在课程详情页展示【粉丝群】按钮，用户购买之后点击加入群聊;</p>
			<p class="tips_item">4、学员申请加入群聊时，若群聊人数达到上限，将无法加入群聊，您可在后台查看群聊状态;</p>
			<p class="tips_item">
				5、点击查看<a :class="classNames+ '_alink'" @click="dyGroupLevels = true">粉丝群等级权益与条件</a>;
			</p>
		</div>
		<el-row :gutter="20" style="margin-bottom: 20px;">
			<el-col :span="5">
				<el-input placeholder="请输入群聊名称" v-model="search.group_name" clearable> </el-input>
			</el-col>
			<el-col :span="5">
				<el-input placeholder="请输入课程名称" v-model="search.product_title" clearable> </el-input>
			</el-col>
			<el-col :span="4">
				<el-select v-model="search.status" placeholder="请选择群聊状态">
					<el-option label="全部" value=""/>
					<el-option label="正常" :value="1"/>
					<el-option label="已满" :value="2"/>
				</el-select>
			</el-col>
			<el-col :span="3">
				<el-button type="primary" @click="getDyGroupIndex">查询</el-button>
			</el-col>
			<el-col :span="7">
				<el-button type="primary" @click="onShowAuths">绑定抖音账号</el-button>
				<el-button type="primary" icon="el-icon-plus" @click="createChat">创建群聊</el-button>
			</el-col>
		</el-row>
		<!-- 群列表 -->
		<div :class="classNames+'_con'">
			<div :class="classNames+'_con_table'">
				<el-table :data="marketList"
					:header-cell-style="{background: '#F5F7FA',color:'#454D53'}">
                    <div slot="empty">
						<img :src="require(`@/assets/image/${noDataName}.png`)" style="width: 100%;padding: 115px 0;"/>
					</div>
					<el-table-column :label="item.label" :prop="item.prop" v-for="(item, index) in headerList"
						:type="item.prop" :key="index" :width="item.width" align="center">
						<template slot-scope="scope">
							<div :class="classNames+ '_table_imgtitle'" v-if="item.prop == 'group_desc'">
								<img :src="scope.row.avatar" class="avatar"/> <span>{{scope.row.name}}</span>
							</div>
							<div v-else-if="item.prop == 'scope_name'" @click="showClass(scope.row)">
								<span :class="classNames+ '_alink'">{{scope.row.scope_name}}</span>
							</div>
							<!-- <template v-if="item.prop === 'shop'">
								<div :class="classNames+ '_table_imgtitle'">
                                    <img :src="scope.row.goods_img"/>
									<div>
										<p>{{scope.row.goods_name}}</p>
										<p>是否购买后展示：{{scope.row.is_buy == 1 ? '否': '是'}}</p>
									</div>
                                </div>
							</template> -->
							<span v-else>{{scope.row[item.prop]}}</span>
						</template>
					</el-table-column>
					<el-table-column label="操作" width="160" align="center">
						<template slot-scope="scope">
							<!-- <span @click="isAllow(scope.row, scope.row.status == 1? '禁用': '启用')" :class="[classNames+'_operation_title']">{{scope.row.status == 1? '禁用': '启用'}}</span> -->
							<span @click="editClass(scope.row)" :class="[classNames+'_operation_title']">关联课程</span>
							<span v-if="scope.row.open_audit_switch != 0" @click="getAuditList(scope.row)" :class="[classNames+'_operation_title']">进群审批</span>
							<span @click="deleteItem(scope.row.id)" :class="[classNames+'_operation_title']">删除</span>
						</template>
					</el-table-column>
				</el-table>
			</div>
			<el-pagination
				style="margin-top: 30px;"
				background
				layout="prev, pager, next"
				:page-count="marketPage.page_total"
				:current-page="marketPage.page"
				@current-change="onChangeMarketPage"
				@prev-click="onChangeMarketPage(marketPage.page - 1)"
				@next-click="onChangeMarketPage(marketPage.page + 1)">
			</el-pagination>
		</div>
		<groupClass v-model.sync="classEditFlag" @sure="sureClass" :ids="editList" :type="groupClassType" ref="groupClass"></groupClass>
		<groupVerify
			v-model="dyGroupVerifys"
			:groupVerifyList="dyAuditList"
			:page="auditPage"
			@toPage="getAuditListToPage"
			@edit="auditListEdit">
		</groupVerify>
		<el-dialog
			title="抖音APP扫码授权"
			:visible.sync="dyGroupVisible"
			width="464px"
			height="440px"
			custom-class="dybind-auth"
			@close="handleClose"
			:close-on-click-modal='false'
			:close-on-press-escape='false'>
			<div class="qrcode">
				<div style="margin-bottom: 30px;">
					授权前，请先确认该授权抖音账号已实名认证且有开播记录，或者粉丝数为万粉，否则授权后不可创建群聊；若账号群聊已达上限，可绑定其他抖音账号。
				</div>
				<div class="qr_code">
					<img
					  @load="loadQrCode"
					  class="qr_code_img"
					  :src="'data:image/png;base64,'+groupStatusInfo.img" 
					  alt=""
					  v-show="isLoadFinish"
					/>
					<i
					  class="el-icon-loading"
					  style="color: #3894ff"
					  v-show="!isLoadFinish"
					></i>
					<div class="expires_mask" v-if="groupQRExpires" @click="gotQRcode()">
					  <div class="mask_tips">二维码已过期</div>
					</div>
				</div>
				
				<div class="tips2" v-if="groupQRExpires" @click="gotQRcode()">刷新二维码</div>
				<div class="tips2" style="color: #333333; cursor: default;" v-else>请打开抖音扫码</div>
			</div>
		</el-dialog>
		<el-dialog
			title="抖音账号"
			:visible.sync="dyGroupAuths"
			width="664px"
			height="440px"
			:custom-class="classNames+'_auths_popup'"
			:close-on-click-modal='false'
			:close-on-press-escape='false'>
			<div class="auths">
				<el-table :data="groupAuthList"
					:header-cell-style="{background: '#F5F7FA',color:'#454D53'}">
		            <div slot="empty">
						<img :src="require(`@/assets/image/${noDataName}.png`)" style="width: 100%;padding: 15px 0;"/>
					</div>
					<el-table-column label="序号" type="index"></el-table-column>
					<el-table-column :label="item.label" :prop="item.prop" v-for="(item, index) in AuthHeaderList"
						:type="item.prop" :key="index" :width="item.width" align="center">
						<template  slot-scope="scope">
							<div :class="classNames+ '_table_imgtitle'"  v-if="item.prop === 'name'">
						        <img :src="scope.row.avatar" class="avatar"/> <span>{{scope.row.name}}</span>
						    </div>
							<span v-else>{{scope.row[item.prop]}}</span>
						</template>
					</el-table-column>
					<el-table-column label="操作" width="140" align="center">
						<template slot-scope="scope">
							<span @click="addAuth()"  v-if="scope.row.is_expire == 1" :class="[classNames+'_operation_title']">重新授权</span>
							<span @click="groupToUnbind()" :class="[classNames+'_operation_title']">解绑</span>
						</template>
					</el-table-column>
				</el-table>

				<a :class="classNames+ '_alink'" style="margin-top: 50px;" @click="addAuth()">绑定抖音账号</a>
				
			</div>
		</el-dialog>
		<el-dialog
			title="粉丝群等级权益与条件"
			:visible.sync="dyGroupLevels"
			width="776px"
			height="354px"
			:custom-class="classNames+'_levels_popup'">
			<div class="level-group">
				<div class="level-item" style="background-image: url(http://img-dbzd.doubaozhidao.com/20230316/1678951077790032.png?x-oss-process=image/quality,q_80/format,jpg);"></div>
				<div class="level-item" style="background-image: url(http://img-dbzd.doubaozhidao.com/20230316/1678951208025070.png?x-oss-process=image/quality,q_80/format,jpg);"></div>
				<div class="level-item" style="background-image: url(http://img-dbzd.doubaozhidao.com/20230316/1678951336707349.png?x-oss-process=image/quality,q_80/format,jpg);"></div>
				<div class="level-item" style="background-image: url(http://img-dbzd.doubaozhidao.com/20230316/1678951350001938.png?x-oss-process=image/quality,q_80/format,jpg);"></div>
			</div>
		</el-dialog>
	</div>
</template>

<script>
	import {
		mapState,
		mapActions
	} from 'vuex'
	import groupClass from './groupClass.vue'
	import groupVerify from './groupVerify.vue'
	export default {
		name: 'GroupChat',
		data() {
			return {
				classNames: 'groupChat',
				AuthHeaderList: [
                    {
                        prop: 'name',
                        label: '抖音号'
                    },
                    {
                        prop: 'create_time',
                        label: '绑定时间',
						width: 180
                    }
                ],
                headerList: [
                    {
                        prop: 'id',
                        label: 'ID',
                        width: 80
                    },
                    {
                        prop: 'group_name',
                        label: '群聊名称',
						width: 200
                    },
                    {
                        prop: 'group_desc',
                        label: '抖音账号',
						width: 180
                    },
					{
					    prop: 'scope_name',
					    label: '关联课程'
					},
                    // {
                    //     prop: 'status_name',
                    //     label: '群聊状态'
                    // },
					{
                        prop: 'group_status_name',
                        label: '群聊状态'
                    },
                    {
                        prop: 'created_time',
                        label: '创建时间',
						width: 200
                    }
                ],
                marketList: [],
				marketPage: {
					page: 1,
					page_total: 1,
					page_size: 10,
				},
                noDataName: 'empty',
				editList: [],
				classEditFlag: false,
				group_id: '',
				isLoadFinish: false,
				dyGroupVisible: false,
				groupStatusInfo: {
					img: '',
					is_show: ''
				},
				availableLength: 0,
				groupAuthList: [],
				loopTimes: 0,
				groupQRExpires: false,
				timer: null,
				
				search: {
					group_name: '',
					product_title: '',
					status: ""
				},
				dyGroupLevels: false,
				dyGroupAuths: false,
				dyGroupVerifys: false,
				auditPage: {
					page: 0,
					page_size: 10,
					total_page: 1,
					group_id: 0
				},
				dyAuditList: [],
				groupClassType: 'edit',

			}
		},
		created() {
            this.getDyGroupIndex()
			this.getGroupAuthInfo()
			
		},
		components: {
			groupClass,
			groupVerify
		},
		computed: {
			...mapState(['breadCrumbList'])
		},
		methods: {
            ...mapActions('groupChat', ['dyGroupIndex', 'dyEditStatus', 'groupScope', 'groupEdit','groupStatus','groupAuthInfo','groupUnbind','auditList', 'auditEdit', 'groupDel']),
            handleBreadCrumb(path, name, id, index = 2) {
				let breadCrumbList = this.breadCrumbList
				breadCrumbList[index] = {
					title: name,
					path: id ? path + '/' + id : path
				}
				localStorage.setItem('breadCrumbList', JSON.stringify(breadCrumbList))
				this.$router.push({
					path: id ? path + '/' + id : path,
				})
				breadCrumbList[index] = {
					title: name,
					path: this.$route.fullPath
				}
			},
			onShowAuths(){
				if(this.groupAuthList.length){
					this.dyGroupAuths = true
				}else{
					this.addAuth()
				}
			},
			// 创建群聊
            createChat() {
				if(this.groupAuthList.length){
					this.handleBreadCrumb('/createGroupChat', '添加群聊')
				}else{
					this.$message({
						type: 'error',
						message: `还没有已授权的账号，请先扫码授权`,
						duration: 3000
					})
					this.addAuth()
				}
            },
			// 添加授权账号 ｜ 重新授权
			addAuth(){
				this.dyGroupVisible = true
				this.getGroupStatus()
			},
            async getDyGroupIndex() {
                let res = await this.dyGroupIndex({...this.search, page: 0, page_size: this.marketPage.page_size})
				this.marketPage = {...this.marketPage, page: 1, page_total: Math.ceil(res.total / this.marketPage.page_size)}
                this.marketList = res.data
            },
			async onChangeMarketPage(page){
				let res = await this.dyGroupIndex({...this.search, page: page, page_size: this.marketPage.page_size})
				this.marketPage = {...this.marketPage, page: page, page_total: Math.ceil(res.total / this.marketPage.page_size)}
                this.marketList = res.data
			},
            isAllow(row, type) {
                // if(row.status_name == '启用') {
                //     return
                // }
                this.$confirm(`确定要${type}该群聊吗？`, '信息', {
					distinguishCancelAndClose: false,
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					customClass: this.classNames + '_common_dialog',
					center: true
				})
				.then(async() => {
					try {
                        await this.dyEditStatus({id: row.id})
                        this.getDyGroupIndex()
                        this.$message(
                            {
                                type: 'success',
                                message: `${type}成功`,
                                duration: 3000
                            }
                        )
                    } catch (error) {
                        
                    }
				})
            },
			// 获取关联课程
			async editClass(row) {
				this.groupClassType = 'edit'
				this.classEditFlag = true
				this.group_id = row.id
				let res = await this.groupScope({id: row.id})
				// console.log(res, 5464564)
				this.editList = res
				this.$refs.groupClass.groupCourseListFun(row.id)
			},
			// 修改关联课程
			async sureClass(data) {
				let product_ids = data.map(item => item.id)
				await this.groupEdit({product_ids, id: this.group_id})
				  this.$message({
        			type: 'success',
        			message: '修改成功'
        		})
				console.log(data, '...data')
			},
			// 获取群聊状态
			async getGroupStatus(status = 1) {
				// status 1 默认获取群聊状态 2 循环获取是否展示群聊信息
				if(this.dyGroupVisible) {
					this.groupQRExpires = false
					const author_id = localStorage.getItem('id')
			    	let res = await this.groupStatus({ author_id:author_id })
					if(res.is_show == 1) {
						this.groupStatusInfo = res
						this.isLoadFinish = true
						this.getLoopGroupStatus()
					} else {
						this.dyGroupVisible = false
						this.dyGroupAuths = true
						// this.handleBreadCrumb('/createGroupChat', '添加群聊')
						await this.getGroupAuthInfo()
					}
				}
			},
			// 获取已授权列表
			async getGroupAuthInfo() {
			  try{
				const author_id = localStorage.getItem('id')
				let res = await this.groupAuthInfo({author_id:author_id})
				this.availableLength = res.available.length || 0
				this.groupAuthList = [...res.available, ...res.overtime]
			   }catch(e){
			   	this.groupAuthList = []
			   }
			},
			loadQrCode(){
				this.isLoadFinish = true
			},
			getLoopGroupStatus(){
				this.loopTimes = 0
				this.timer = setInterval(async () => {
				  this.loopTimes++
				  if(this.loopTimes >= 30) {
					  this.groupQRExpires = true
					  clearInterval(this.timer);
				  }
				  const author_id = localStorage.getItem('id')
				//   let res = await this.groupStatus({author_id:author_id})
				  let res = await this.groupAuthInfo({author_id:author_id})
				this.groupAuthList = [...res.available, ...res.overtime]
				  if(res.available?.length > this.availableLength){
					this.dyGroupVisible = false
					this.groupQRExpires = false
					clearInterval(this.timer);
					this.availableLength = res.available.length || 0
					this.dyGroupAuths = true
				}
				
				//   try{
				//   	if(res.is_show == 1) {
				// 		this.groupStatusInfo = res
				// 		this.isLoadFinish = true
				//   	} else {
				// 		this.dyGroupVisible = false
				// 		this.groupQRExpires = false
				// 		clearInterval(this.timer);
				// 		this.handleBreadCrumb('/createGroupChat', '添加群聊')
				// 		await this.getGroupAuthInfo()
				// 	}
				//   }catch(e){
				// 	this.groupQRExpires = false
				// 	clearInterval(this.timer);
				// 	console.log('出错了');
				//   }
				}, 2000);
			},
			gotQRcode(){
				this.groupQRExpires = false
				this.isLoadFinish = false
				// this.getLoopGroupStatus()
				this.getGroupStatus()
			},
			handleClose() {
				this.isLoadFinish = false
				this.dyGroupVisible = false
				clearInterval(this.timer);
			},
			// 解绑
			async groupToUnbind(){
				try{
					const author_id = localStorage.getItem('id')
					await this.groupUnbind({author_id:author_id})
					this.$message({
						type: 'success',
						message: '抖音账号解绑成功'
					})
					await this.getGroupAuthInfo()
				 }catch(e){
					 
				 }
			},
			// 进群审批列表第一页
			async getAuditList(row){
				this.auditPage = {...this.auditPage, page: 0, group_id: row.id}
				let res = await this.auditList({...this.auditPage})
				console.log(res)
				this.dyGroupVerifys = true
				this.auditPage = {...this.auditPage, ...res.page_info}
				this.dyAuditList = res.list || []
			},
			// 进群审批列表上一页下一页
			async getAuditListToPage(page){
				this.auditPage = {...this.auditPage, page: page}
				let res = await this.auditList({...this.auditPage})
				this.auditPage = {...this.auditPage, ...res.page_info}
				this.dyAuditList = res.list || []
			},
			// 审批
			async auditListEdit(params){
				let res = await this.auditEdit(params)
				if(res && res.success){
					this.getAuditListToPage(this.auditPage.page || 1)
					this.$message({
						type: 'success',
						message: `审批完成`
					})
				}else{
					this.$message({
						type: 'error',
						message: `审批失败，请稍后重试`,
						duration: 3000
					})
				}
				
			},
			// 显示已选课程
			async showClass(row){
				this.groupClassType = 'show'
				this.classEditFlag = true
				let res = await this.groupScope({id: row.id})
				this.editList = res
				this.$refs.groupClass.groupCourseListFun(row.id)
			},
			async deleteItem(id) {
				this.$confirm(`你确定要删除该群聊吗?`, '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(async () => {
					await this.groupDel({
						id
					})
					this.getDyGroupIndex()
					this.$message({
						type: 'success',
						message:'删除成功',
						duration: 3000
					})
				})    
			}
		}
	}
</script>
<style lang="less">
	.dybind-auth{
		height: 450px;
			.el-dialog__header {
				padding: 16px 24px;
				border-bottom: 1px solid #EEEEEE;
				.el-dialog__title {
					font-size: 16px;
					font-weight: 500;
					color: #333333;
					line-height: 24px;
				}
			}
			.el-dialog__body {
				padding: 24px;
				display: flex;
				flex-direction: column;
				justify-content: center;
			}
			.qrcode {
				display: flex;
				flex-direction: column;
				align-items: center;
				p {
					font-size: 14px;
					color: #000000;
					margin-top: 20px;
					span {
						line-height: 20px;
					}
				}
				.tips2 {
				  font-size: 14px;
				  font-family: PingFangSC-Regular, PingFang SC;
				  font-weight: 400;
				  color: rgba(59, 130, 246, 1);
				  margin-top: 20px;
				  text-align: center;
				  cursor: pointer;
				}
			}
			.qr_code {
			  width: 200px;
			  height: 200px;
			  margin: 0 auto;
			  position: relative;
			  display: flex;
			  justify-content: center;
			  align-items: center;
			  .qr_code_img {
			    display: block;
			    width: 200px;
			    height: 200px;
			  }
			  .el-icon-loading {
			    font-size: 60px;
			  }
			  .expires_mask {
			    width: 100%;
			    height: 100%;
			    background-color: rgba(255, 255, 255, 0.8);
			    position: absolute;
			    top: 0;
			    left: 0;
			    z-index: 7;
			    display: flex;
			    justify-content: center;
			    align-items: center;
			    .mask_tips {
			      border-radius: 15px;
			      background-color: #ffffff;
			      color: rgba(0, 0, 0, 0.65);
			      font-size: 14px;
			      display: flex;
			      justify-content: center;
			      align-items: center;
			    }
			  }
			}
	}
	@classNames: groupChat;
	.@{classNames}_levels_popup{
		border-radius: 6px;
		.el-dialog__close{
			font-size: 24px;
			color: #323233;
		}
	}
	.@{classNames}_auths_popup{
		.auths{
			text-align: center;
		}
	}
	.@{classNames} {
		.el-table::before {
			background-color: transparent;
		}
		.@{classNames}_search_btn {
			width: 70px;
			height: 40px;
			background: #1989FA;
			border-radius: 0px 2px 2px 0px;
			color: #FFFFFF;
			font-size: 14px;
		}
		.@{classNames}_operation_title {
			margin-right: 12px;
			font-size: 14px;
            cursor: pointer;
            color: #1989FA;
            // &.@{classNames}_operation_title1 {
			    
            // }

		}
		.@{classNames}_table_imgtitle {
			display: flex;
			align-items: center;
			justify-content: center;
			.avatar{
				width: 25px;
				height: 25px;
				margin-right: 10px;
				border-radius: 50%;
			}
			img{
				width: 25px;
				height: 25px;
				margin-right: 10px;
				border-radius: 50%;
			}
		}
		.@{classNames}_search_con_item {
			.el-input-group__append {
				background: #1989FA;
				color: #fff;
			}
		}
		.el-table__header {
			width: 100%!important;
		}
		.el-table__body {
			width: 100%!important;
		}
	}
	.@{classNames}_common_dialog {
		padding: 30px;
		width: 360px;
		box-sizing: border-box;
		.el-message-box__header {
			padding: 0;
		}
		.el-message-box__headerbtn {
			top: 0;
			right: 0;
		}
		.el-message-box__content {
			padding: 0;
			.el-message-box__message {
				padding-top: 12px;
				padding-bottom: 16px;
			}
		}
		.el-message-box__btns {
			.el-button {
				width: 77px;
				height: 28px;
				padding: 0;
				text-align: center;
				line-height: 28px;
			}
		}
	}
</style>

<style lang='less' scoped>
	@classNames: groupChat;

	.@{classNames} {
		display: flex;
		flex-direction: column;
		height: 100%;
		.@{classNames}_title{
			display: flex;
			align-items: flex-end;
			margin-bottom: 20px;
			font-size: 18px;
			font-weight: bold;
		}
		.@{classNames}_alink{
			color:#1989fa;
			cursor:pointer;
			font-size:14px;
			text-decoration:none;
			display: inline-block;
		}
		.@{classNames}_tips{
			padding: 10px 20px;
			border-radius: 4px;
			background-color: rgb(242, 242, 242);
			font-size: 14px;
			margin-bottom: 20px;
			line-height: 3;
		}
		.@{classNames}_levels_popup{
			.level-group{
				display: flex;
				justify-content: space-between;
				.level-item{
					height: 260px;
					width: 170px;
					margin-right: 16px;
					border-radius: 6px;
					background-color: #FAFAFC;
					overflow: hidden;
					background-size: 100% 100%;
				}
				.level-item:last-child{
					margin-right: 0;
				}
			}
		}
		.@{classNames}_search {
			display: flex;
			justify-content: space-between;
			margin-bottom: 40px;
			flex-shrink: 0;

			.@{classNames}_search_con {
				display: flex;

				.@{classNames}_search_con_item {
					display: flex;
					align-items: center;
					margin-right: 16px;

					.@{classNames}_search_con_item_title {
						white-space: nowrap;
						font-size: 14px;
						color: #606266;
						margin-right: 12px;
					}
				}
			}
		}

		.@{classNames}_con {	
			display: flex;
			flex-direction: column;
			flex: 1;
		}
	}
</style>
